<div class="hide-acc">
  <div class="error-container" aria-live="assertive">
    <div class="alert valign-children-middle" *ngIf="errorMessage">
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2>Error!</h2>
        <p>{{ this.errorMessage }</p>
      </div>
    </div>
  </div>
  <section *ngIf="cart !== null">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-md-offset-3 checkout-body">
        <div class="checkout-subheader" *ngIf="responseProductSpecifications && responseProductSpecifications.length === 1">Provide details about the administrator.</div>
        <div class="checkout-subheader" *ngIf="responseProductSpecifications && responseProductSpecifications.length > 1">Provide details about the administrator of each product.</div>
        <div role="tablist" class="tiny-accordion" data-scroll-top="false" multiselectable="true">
          <div *ngIf="formBuilderCheck">
            <div *ngFor="let productSpecification of responseProductSpecifications;let i = index">
              <div *ngIf="responseProductSpecifications.length > 1" class="toggle-header">
                <a href="javascript:void(0)" (click)="openAccordion(i,responseProductSpecifications.length)" [attr.aria-controls]="'detailsPanel'+i"
                  [attr.aria-label]="!this.accordionList[i] ? productSpecification.displayName + '.Expand this section.': productSpecification.displayName + '.Collapse this section.'">
                  <i *ngIf="!this.accordionList[i] && responseProductSpecifications.length > 1"  class="icon-accordion-plus" aria-hidden="true"></i>
                    <i *ngIf="this.accordionList[i] && responseProductSpecifications.length > 1"  class="icon-accordion-minus" aria-hidden="true"></i>
                        <span *ngIf="(responseProductSpecifications.length > 1)">{{ i + 1}}. {{productSpecification.displayName}}</span>
                          </a>               
            </div>           
              <span class="toggle-header no-cursor" *ngIf="(responseProductSpecifications.length === 1)">{{productSpecification.displayName}}</span>
                <div [class.showpanel]="!this.accordionList[i]" [attr.id]="'detailsPanel'+i">
                  <app-form-builder [formConfig]="productSpecification.configurations" [formName]="productSpecification.dcmCode" (formOutput)="getFormConfigDetails($event,i,productSpecification.dcmCode)"
                    (modelOutput)="showTermsCondition($event)"></app-form-builder>
                  <div class="clearfix"></div>
                  <div class="tnc" *ngIf="this.tncMap.get(productSpecification.dcmCode) && this.tncMap.get(productSpecification.dcmCode) !== undefined ">
                    <p class="last-text">Legal agreement</p>
                    <p>
                      {{productSpecification.displayName}} is subject to its <a [attr.aria-label]=" productSpecification.displayName + ' Terms of Service  (Opens in new window)' "
                        href="javascript:void(0)" (click)="redirectTermsCondition(productSpecification.dcmCode)">
                   Terms of Use</a>
                    </p>
                  </div>
                  <div *ngIf="(i === 0) && (responseProductSpecifications.length !== (i+1))">
                    <label [attr.for]="'productSpecification'+i" class="checkbox">
                <input type="checkbox" id="{{'productSpecification' + i}}"
                [disabled]="!this.formConfiguration.formProperty[i].formStatus"
                [checked]="this.cart.isApplySame"
                  (click)="updateInputValues($event.target.checked)">
                <i class="skin"></i>
                <span >Apply the same administrator details to all products I'm buying.</span>
              </label>
                  </div>
                  <div class="clearfix"></div>
                  <div *ngIf="responseProductSpecifications.length !== (i+1)">
                    <button [disabled]="!this.formConfiguration.formProperty[i].formStatus" class="btn btn-secondary btn-next" (click)="openAccordion(i+1)"
                      aria-label="Next.">Next</button>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <hr class="bottom-hr" />
        <div class="line-footer text-right">
          <button type="button" href="javascript:void(0)" *ngIf="!formValid" disabled class="btn btn-secondary pull-right" (click)="goToReviewOrder()"
            aria-label="Enter the required details to continue.">Continue</button>
          <button type="button" href="javascript:void(0)" *ngIf="formValid" class="btn btn-secondary pull-right" (click)="goToReviewOrder()"
            aria-label="Continue.">Continue</button>
          <a class="btn btn-link" href="javascript:void(0);" (click)="goToBilling()"> Back </a>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </section>
</div>
<!-- <div *ngIf="this.termsConditionPopup">
  <app-terms-content [showModal]="termsConditionPopup" [title]='popupTitle' [triggerElement]='eventEmit' [contentUrl]="popupUrl"
    (modalOutput)="this.termsConditionPopup =  false"></app-terms-content>
</div> -->